import {component} from '@reduct/component';

@component({})
export default class Button {
    constructor() {
        let link = this.el.querySelector('a');

        this.el.addEventListener('click', () => {
            link.click();
        });

        this.createMobileCta();
    }

    createMobileCta() {
        if (document.querySelector('#mobile-cta') !== null) {
            return;
        }

        let firstCta = document.querySelector('.button.cta');

        let mobileCta = firstCta.cloneNode(true);
        mobileCta.id = 'mobile-cta';

        document.querySelector('body').appendChild(mobileCta);
    }
}
